import {
  HeadingProps as ChakraHeadingProps,
  Heading as ChakraHeading,
} from "@chakra-ui/react";
import { ReactElement, ReactNode } from "react";

export type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

const SIZE_LOOKUP: Record<HeadingLevel, ChakraHeadingProps["size"]> = {
  1: "5xl",
  2: "4xl",
  3: "3xl",
  4: "2xl",
  5: "xl",
  6: "lg",
};

interface HeadingProps extends Omit<ChakraHeadingProps, "size"> {
  level: HeadingLevel;
  children: ReactNode;
}

export default function Heading(props: HeadingProps): ReactElement {
  const { level, children, ...rest } = props;

  return (
    <ChakraHeading fontSize={SIZE_LOOKUP[level]} {...rest}>
      {children}
    </ChakraHeading>
  );
}
